<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Transfer Stock</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="mt-1">
          <v-btn color="primary" small to="/create-stock-transfer">
            <v-icon left dark>mdi-plus</v-icon>Transfer Stock / Create Draft
          </v-btn>
        </v-row>

        <v-row dense>
          <v-col cols="12" class="mt-4">
            <v-text-field dense label="Search" v-model="search"></v-text-field>
          </v-col>

          <v-divider></v-divider>

          <v-col cols="12" class="subtitle-2 text--primary">
            <v-data-table
              :mobile-breakpoint="zeroValue"
              :headers="headers"
              :items="reportData"
              :search="search"
            >
              <!-- date template -->
              <template v-slot:item.date="{ item }">{{ item.date | date}}</template>
              <!-- end of date template -->

              <!-- date template -->
              <template v-slot:item.DocTotal="{ item }">{{ item.DocTotal | currency }}</template>
              <!-- end of date template -->

              <!-- status template -->
              <template v-slot:item.status>
                <span style="color: orange; font-weight: bold;">Transfer Draft</span>
              </template>
              <!-- end of status template -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="accent" text :to="`/edit/transfer/draft/${item.id}`">
                  <v-icon left>mdi-eye</v-icon>More Details
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.delete="{ item }">
                <v-btn color="red" icon @click="deleteDraftModal(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>

            <!-- product dialog modal-->
            <v-dialog v-model="deleteDialog" max-width="750px">
              <v-card>
                <v-toolbar dense color="secondary" flat>
                  <v-toolbar-title>Delete Transfer Draft</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.native="deleteDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-container fluid>
                    <v-row class="text--primary subtitle-2">
                      <v-col cols="12">Are you sure you want to delete / disable this transfer?</v-col>
                      <v-col cols="6">
                        <span
                          style="font-size: 16px"
                        >{{ transferToDelete.fromStore && transferToDelete.fromStore.Name }}</span>
                      </v-col>

                      <v-col cols="6">
                        <span
                          style="font-size: 16px"
                        >{{ transferToDelete.toStore && transferToDelete.toStore.Name }}</span>
                      </v-col>

                      <v-col cols="12">
                        <span
                          style="font-size: 16px"
                        >Total: {{ transferToDelete.DocTotal | currency }}</span>
                      </v-col>

                      <v-col cols="12">
                        <v-btn
                          color="red"
                          dark
                          :loading="loader"
                          @click="deleteTransferDraft"
                        >Yes, Delete</v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
            <!-- end of modal-->

            <snackbar ref="snackbar"></snackbar>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
  
  <script>
export default {
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    role() {
      return localStorage.getItem("userRole");
    }
  },
  data() {
    return {
      record: {},
      deleteDialog: false,
      productsDialog: false,
      salesLoader: false,
      transferToDelete: {},
      soldItems: [],
      pageItems: 100,
      zeroValue: 0,
      menu1: false,
      menu2: false,
      loader: false,
      search: null,
      customers: [],
      stores: [],
      users: [],
      reportData: [],
      headers: [
        { text: "From", value: "fromStore.Name" },
        { text: "To: Customer", value: "customer.Name" },
        { text: "To: Branch / Store", value: "toStore.Name" },
        { text: "Total", value: "DocTotal" },
        { text: "Date", value: "date" },
        { text: "Created By", value: "user.name" },
        { text: "Picked By", value: "pickedBy.name" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" },
        { text: "Delete", value: "delete" }
      ]
    };
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    deleteDraftModal(item) {
      this.transferToDelete = item;
      this.deleteDialog = true;
    },
    getDrafts() {
      const url = "/stock-transfer-drafts";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.reportData = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    deleteTransferDraft() {
      const url = `/delete-transfer-draft/${this.transferToDelete.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("remove", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.transferToDelete = {};
            self.getDrafts();
          } else {
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$refs.snackbar.show(err, "red");
        })
        .finally(() => {
          self.deleteDialog = false;
          self.loader = false;
        });
    }
  },
  created() {
    this.getDrafts();
  }
};
</script>
  
  <style lang="scss" scoped>
</style>